import servicosSolicitacaoExterna from "../../servicos/servicos-solicitacao-externa";
import servicosItemPedido from "../../servicos/servicos-item-pedido";
import { useContext, useEffect, useRef, useState } from "react";
import AuthContext from "../../servicos/autorizacao/AuthContex";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { localizedTextsMap } from "../../utils/localizedTextsMap";
import moment from "moment";
import { Modal } from "react-bootstrap";
import Cancel from "../../img/svgs/Cancel";
import Salvar from "../../img/svgs/Salvar";
import { toast, ToastContainer } from "react-toastify";
import List from "../../img/svgs/List";
import NavMobile from "../components/NavMobile";
import Edit from "../../img/svgs/Edit";

const ListMinhasSolicitacoesExternas = () => {
    const { user } = useContext(AuthContext);
    const [minhasSolicitacoes, setMinhasSolicitacoes] = useState([]);
    const [show, setShow] = useState(false);
    const [showDetalhes, setShowDetalhes] = useState(false);
    const [editado, setEditado] = useState(false);
    const handleClose = () => setShow(false);
    const handleCloseDetalhes = () => setShowDetalhes(false);
    const motivo_cancelamento = useRef();
    const [solicitacao, setSolicitacao] = useState([]);
    const [pedido, setPedido] = useState([]);
    const [showObservacao, setShowObservacao] = useState(false);
    const handleCloseObservacao = () => setShowObservacao(false);

    const cancelarSolicitacao = () => {
        setEditado(false);
        let motivo = motivo_cancelamento.current.value;
        if (motivo === '') {
            toast.error('Por favor nos informe o motivo do cancelamento')
        } else {
            servicosSolicitacaoExterna.cancelarPedido(solicitacao.id_solicitacao_externa, motivo).then(response => {
                if (response.status === 200) {
                    toast.success('Solicitação cancelada com sucesso!');
                    setShow(false);
                    setEditado(true);
                }
            }).catch(error => console.log(error));
        }

    }

    const handleShow = (solicitacao) => {
        setSolicitacao(solicitacao);
        setShow(true);
    }

    const handleShowDetalhes = (pedido) => {
        let id = pedido.id_solicitacao_externa;
        let listaItems = [];
        servicosItemPedido.listarUm(id).then(response => {
            if (response.status === 200) {
                listaItems = response.data;
                let item = {
                    id: id,
                    items: listaItems,
                    pedido: pedido
                }

                setPedido(item);

                setShowDetalhes(true);
            }
        })

    }

    const handleShowObservacao = (solicitacao) => {
        setSolicitacao(solicitacao);
        setShowObservacao(true);
    }

    useEffect(() => {
        servicosSolicitacaoExterna.listarSolicitacaoExternaPorColaborador(user.id).then(response => {
            if (response.status === 200) {
                setMinhasSolicitacoes(response.data);
            }
        }).catch(error => console.log(error));
    }, [editado, user.id]);

    const columnsSolicitacoes = [
        {
            field: "id_solicitacao_extern",
            headerName: "",
            align: "center",
            width: 70,
            renderCell: (params) => {
                return <button type="button" onClick={() => handleShowDetalhes(params.row)}><List /></button>
            }
        },
        {
            field: "id_solicitacao_externa",
            headerName: "Pedido",
            align: "center",
            width: 70,
            renderCell: (params) => {
                return params.row.id_solicitacao_externa;
            }
        },
        { field: "cdg_parceiro", headerName: "CÓD. AGENTE", width: 100 },
        { field: "milhas_solicitacao", headerName: "MILHAS", width: 70 },
        { field: "status", headerName: "Status", width: 100 },
        { field: "responsavel", headerName: "Responsável", width: 150, editable: 'true' },
        {
            field: "observacao",
            headerName: 'Observação',
            align: "center",
            sortable: false,
            renderCell: (params) => {
                return <button className="btn-icones rounded p-1" onClick={() => handleShowObservacao(params.row)}><Edit /> Visualizar</button>;
            }
        },
        { field: "motivo_solicitacao", headerName: "Motivo Sol.", width: 150, editable: 'true' },
        {
            field: "data_solicitacao",
            headerName: "Data Solicitação",
            width: 100,
            valueGetter: (params) => {
                return moment(params.row?.data_solicitacao).format('DD-MM-YYYY')
            }
        },
        {
            field: "data_entrega",
            headerName: "Data Entrega",
            width: 100,
            valueGetter: (params) => {
                if (params.row.data_entrega) {
                    return moment(params.row?.data_entrega).format('DD-MM-YYYY')
                } else {
                    return ""
                }
            },
        },
        {
            field: "cancelar",
            headerName: "Cancelar",
            align: "center",
            width: 100,
            sortable: false,
            renderCell: (params) => {
                if (params.row?.status === 'pendente') {
                    return <button className="border-0 rounded btn-icones p-1" onClick={() => handleShow(params.row)} ><Cancel /></button>;
                } else {
                    return <button className="border-0 rounded btn-icones p-1 " disabled ></button>;
                }
            }
        }
    ];

    const ModalEditar = () => {
        return <>

            <Modal className="" show={show} onHide={handleClose}>
                <Modal.Body className="modal-edicao" >
                    <div >
                        <div className="d-flex justify-content-center">
                            {solicitacao  && <div>

                                Você deseja realmente cancelar essa solicitação?
                                <br></br>
                                {solicitacao.Produto && <span>Produto: <strong>{solicitacao.Produto[0].nome}</strong></span>}
                                <br></br>
                                <span>Quantidade: <strong>{solicitacao?.qtd_solicitada}</strong></span>
                                <br></br>
                                Motivo:
                                <br></br>
                                <textarea ref={motivo_cancelamento} id="motivo_cancelamento">
                                </textarea>

                                <div className="text-center mt-4">
                                    <button onClick={cancelarSolicitacao} className="btn-icones p-1 rounded w-25 me-3" >
                                        <Salvar /> Salvar
                                    </button>
                                    <button className="btn-icones p-1 rounded w-25" onClick={handleClose}>
                                        <Cancel /> Voltar
                                    </button>
                                </div>

                            </div>
                            }
                        </div>


                    </div>

                </Modal.Body>

            </Modal>

        </>
    }

    const ModalObservacao = () => {
        return <>
            <Modal className="modal-lg " show={showObservacao} onHide={handleCloseObservacao}>
                <Modal.Body className="modal-edicao" >
                    <div className="text-center mt-4">
                        <span>Detalhes do envio</span>
                        <textarea style={{ fontSize: 16 }} disabled className="w-100 h-100" defaultValue={solicitacao?.observacao ? solicitacao?.observacao : "Por enquanto nenhuma observação sobre o pedido foi adicionado."} id="observacao">
                        </textarea>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn-icones p-1 rounded " variant="secondary" onClick={handleCloseObservacao}>
                        <Cancel /> Fechar
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    }
    const ModalDetalhamentoPedido = () => {
        return <>

            <Modal className="modal-lg " show={showDetalhes} onHide={handleCloseDetalhes}>
                <Modal.Body className="modal-edica" >
                    <div >
                        <div className="d-flex justify-content-center">

                            {
                                pedido.pedido && <div>
                                    <div className="info-solicitacao-externa p-1 d-flex justify-content-between">
                                        <span style={{ fontSize: 18 }} className="ms-2">Dados Solicitação:</span>
                                        <button style={{ width: 10 }} className=" p-1 rounded w-25" onClick={handleCloseDetalhes}>
                                            <Cancel /> Voltar
                                        </button>
                                    </div>
                                    <div className="dados-solicitacao-externa d-flex ">
                                        <div className="w-50 mt-3 ms-2">
                                            <div>Pedido: <span className="font-weight-bold">{pedido.id}</span></div><br />
                                            <div>Código Agente: <span className="font-weight-bold">{pedido.pedido.cdg_parceiro}</span></div>
                                            <div>Data Solicitação: <span className="font-weight-bold">{pedido.pedido.data_solicitacao}</span></div>
                                            <div>Data Entrega: <span className="font-weight-bold">{pedido.pedido.data_entrega}</span></div>
                                            <div>Total Solicitação:<span className="font-weight-bold">{pedido.pedido.milhas_solicitacao}</span></div>
                                            <div>Motivo Solicitação: <span className="font-weight-bold">{pedido.pedido.motivo_solicitacao}</span></div>
                                            <div>Observação: <span className="font-weight-bold">{pedido.pedido.observacao}</span></div>
                                            <div>Responsável: <span className="font-weight-bold">{pedido.pedido.responsavel}</span></div>
                                            <div>Status: <span className="font-weight-bold">{pedido.pedido.status}</span></div>
                                        </div>
                                        <ListaItemsPedido lista={pedido} />
                                    </div>

                                    {/* {pedido.items[0]?.Produto[0].nome} */}

                                </div>
                            }


                        </div>

                    </div>

                </Modal.Body>

            </Modal>

        </>
    }

    const ListaItemsPedido = (props) => {
        return <>
            {props.lista !== undefined && <div className="w-50 mt-4">
                <table className="lista-items-dados-solicitacao">
                    <thead>
                        <tr className="border">
                            <th>Produto</th>
                            {/* <th className="text-center">Milhas</th> */}
                            <th>Tamanho</th>
                            <th className="text-center">Qtd</th>
                            <th className="text-center">Subtotal</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.lista.items.map(item => {
                            return <tr className="border" key={item.Produto[0].id_produto}>
                                <td width={100}>{item.Produto[0].nome}</td>
                                <td width={80} className="text-center">{item.Produto[0].tamanho}</td>
                                <td width={60} className="text-center">{item.qtd_produto}</td>
                                <td className="text-center">{item.milhas}</td>
                            </tr>
                        })}
                    </tbody>

                </table>
            </div>}
        </>
    }

    const styleH3 = {
        color: "#753BBD",
        fontSize: "24px"
    }
    return <>
        {/* <NavMenu /> */}
        <ModalEditar />
        <ModalObservacao />
        <ModalDetalhamentoPedido />
        <ToastContainer />
        <h3 style={styleH3} className="subtitulo text-center mb-3">Minhas Solicitações de Produção</h3>
        <div className="container">
            <a className="subtitulo" style={{ fontSize: 24 }} href="/">Home</a>
            <a className="subtitulo ms-3" style={{ fontSize: 24 }} href="/SolicitacoesExterna">Menu Anterior</a>
            <div className="d-flex row justify-content-center align-items-center">

                <Box sx={{ height: 600, width: 1300, marginTop: 10.5 }} >
                    <DataGrid
                        localeText={localizedTextsMap}
                        rows={minhasSolicitacoes}
                        columns={columnsSolicitacoes}
                        pageSize={10}
                        rowsPerPageOptions={[10]}
                        disableSelectionOnClick
                        getRowId={(row) => row.id_solicitacao_externa}
                        getRowClassName={(params) =>
                            params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd'
                        }
                    />
                </Box>
            </div>
        </div>
        <NavMobile />
    </>
}

export default ListMinhasSolicitacoesExternas;